import { Link } from "react-router-dom";
import styles from "./ToolCard.module.css";
import { trackToolClick } from "shared/services/analytics";

function ToolCard({ tool }) {
  return (
    <Link
      to={`/tools/${tool.title}`}
      className={styles.linkWrapper}
      aria-label={`View details for ${tool.title}`}
      onClick={() => trackToolClick(tool.title)}
    >
      <div className={styles.toolCard}>
        <div className={styles.toolImage}>
          <img src={tool.logo} alt={tool.title} loading="lazy" />
        </div>
        <div className={styles.toolBanner}>
          <h3>{tool.title}</h3>
          <p>{tool.description}</p>
        </div>
      </div>
    </Link>
  );
}

export default ToolCard;
